import type { ShiftProductionFormListItem } from "../../../shared/shift-production-form/contracts";
import { ApprovalFormPreview } from "./ApprovalFormPreview";
import { ApprovalShiftPreviews } from "./ApprovalShiftPreviews";

const shiftOrder = { "00_08": 0, "08_16": 1, "16_00": 2 };

export function GroupedApprovalPreviews({ items, busy, approved = false, showEmptyShifts = false, label, onOpen }: {
  items: ShiftProductionFormListItem[];
  busy: boolean;
  approved?: boolean;
  showEmptyShifts?: boolean;
  label: string;
  onOpen: (id: string) => void;
}) {
  const groups = new Map<string, { department: string; machines: Map<string, ShiftProductionFormListItem[]> }>();
  for (const item of items) {
    const department = item.previewPayload?.departmentName ?? "Diğer formlar";
    const machine = item.lineName ?? "Makine belirtilmedi";
    const group = groups.get(department) ?? { department, machines: new Map() };
    const forms = group.machines.get(machine) ?? [];
    forms.push(item);
    group.machines.set(machine, forms);
    groups.set(department, group);
  }
  for (const group of groups.values()) {
    for (const forms of group.machines.values()) {
      forms.sort((left, right) =>
        (left.shift ? shiftOrder[left.shift] : 3) - (right.shift ? shiftOrder[right.shift] : 3),
      );
    }
  }
  return (
    <div className="approval-form-groups" aria-label={label}>
      {[...groups.values()].map(group => <section className="approval-form-group" key={group.department} aria-label={group.department}>
        <h3>{group.department}</h3>
        {[...group.machines].map(([machine, forms]) => <section className="approval-machine-group" key={machine} aria-label={machine}>
          <header><h4>{machine}</h4><span>{forms.length} form</span></header>
          {showEmptyShifts ? <ApprovalShiftPreviews items={forms} busy={busy} onOpen={onOpen} /> : <div className="approval-form-previews">
            {forms.map(item => <ApprovalFormPreview key={item.id} item={item} approved={approved} disabled={busy} onOpen={onOpen} />)}
          </div>}
        </section>)}
      </section>)}
    </div>
  );
}
